import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Button from 'src/component/UI/Button';
import { FormHelperText, InputLabel } from '@mui/material';
import DeviceLinkCombo from 'src/component/UI/DeviceLinkCombo';
import { createDeviceGroup, updateDeviceGroup } from 'src/module/groupDevices/action';
import { useLocation } from "react-router-dom";
import { useTranslation } from 'src/i18n';

export default function CreateGroupModal ({ deviceIds, open, handleClose, groupId, initialGroupName, editingGroup }) {
  const dispatch: any = useDispatch();
  const { t, tPlural } = useTranslation();
  const [error, setError] = useState(false);
  const [groupName, setGroupName] = useState(initialGroupName);
  const location = useLocation();
  const isEdit = Boolean(groupId);

  // In edit mode the group name arrives with the fetched group, which can land after this
  // modal has mounted — adopt it, but never over top of something the user has typed.
  const nameTouched = useRef(false);
  useEffect(() => {
    if (nameTouched.current) {
      return;
    }
    setGroupName(initialGroupName);
  }, [initialGroupName]);

  const saveGroup = () => {
    if (groupName != '') {
      const redirect = location.pathname !== '/program/list/wizard';
      if (isEdit) {
        dispatch(updateDeviceGroup(groupId, groupName, deviceIds, redirect));
      } else {
        dispatch(createDeviceGroup(groupName, [deviceIds], redirect));
      }
      handleClose();
      if (!isEdit) {
        nameTouched.current = false;
        setGroupName('');
      }
    } else {
      setError(true);
    }

    return;
  };
  const devicesCol = (devices, showAll = false) => {
    if (!devices || !devices.length) {
      return [];
    }
    if (devices.size > 10  && !showAll) {
      const first10 = devices.slice(0, 10);
      return <>
        {first10.map((device, index) => (<div key={index} className='groups-list'><DeviceLinkCombo deviceId={device} /></div>))}
        <>{tPlural('createGroup.plusMore', devices.size-10)}</>
      </>;
    }
    return devices.map((device, index) => (<div key={index} className='groups-list'><DeviceLinkCombo deviceId={device} /></div>));
  };
  const handleGroupNameChange = (event) => {
    nameTouched.current = true;
    setGroupName(event);
    if (event === '') {
      setError(true);
    } else {
      setError(false);
    }
  };

  const renderGroupName = () => {
    if (editingGroup) {
      return (
        <div>
          <TextField required disabled label={t('createGroup.groupName')} fullWidth value={groupName} error={error} onChange={(e) => { handleGroupNameChange(e.target.value);}}  />
        </div>
      );
    }

    return (
      <div>
        <TextField required  label={t('createGroup.groupName')} fullWidth value={groupName} error={error} onChange={(e) => { handleGroupNameChange(e.target.value);}}  />
        {error && <FormHelperText error={Boolean(error)}>{t('createGroup.required')}</FormHelperText>}
      </div>
    );
  };

  return (
    <Modal
      data-testid='create-device-group-modal'
      open={open}
      onClose={handleClose}
      aria-labelledby='create-device-group-modal'
    >
      <div className='modal confirm-modal'>
        <h2 id='confirm-modal-title'>{isEdit ? t('createGroup.editGroup') : t('createGroup.title')}</h2>
        <form onSubmit={saveGroup}>
          <div>
            {renderGroupName()}
            <div style={{ paddingTop: '5px' }}>
              <InputLabel>{t('createGroup.devices')}</InputLabel>
              <div style={{ height: '170px', overflowY: 'auto' }}>{devicesCol(deviceIds, true)}</div>
            </div>
          </div>

          <div className='button-bar'>
            <Button cta onClick={saveGroup} >{t('createGroup.saveGroup')}</Button>
          </div>
        </form>




      </div>

    </Modal>
  );
}

CreateGroupModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  deviceIds: PropTypes.array.isRequired,
  groupId: PropTypes.string,
  initialGroupName: PropTypes.string,
  editingGroup: PropTypes.bool,
};

CreateGroupModal.defaultProps = {
  groupId: null,
  initialGroupName: '',
  editingGroup: false,
};
